import './GuardianOfZone.css';

export default function CoreGuardian() {
  return (
    <svg className="guardian-svg guardian-core" viewBox="0 -5 100 165" overflow="visible" role="img">
      <title>Núcleo — El Tecno-Mago Ancestral</title>
      <style>
        {`
          @keyframes core-float-vertical {
            0% { transform: translateY(-3px); }
            100% { transform: translateY(6px); }
          }
          @keyframes face-pulse-subtle {
            0% { transform: scale(0.95); opacity: 0.8; }
            100% { transform: scale(1.02); opacity: 1; }
          }
          .core-float-anim { animation: core-float-vertical 4s ease-in-out infinite alternate; }
          .face-pulse-anim { animation: face-pulse-subtle 3s ease-in-out infinite alternate; }
        `}
      </style>

      {/* Background magical/data rings floating behind */}
      <g className="g-spin-a" opacity="0.3">
        <circle cx="50" cy="75" r="45" fill="none" className="g-stroke-a" strokeWidth="1" strokeDasharray="5,10,15,5" />
        <circle cx="50" cy="75" r="38" fill="none" className="g-stroke-b" strokeWidth="0.5" strokeDasharray="10,5" />
      </g>
      <g className="g-spin-b" opacity="0.4">
        <circle cx="50" cy="75" r="48" fill="none" className="g-stroke-b" strokeWidth="0.8" strokeDasharray="4,20" />
      </g>

      {/* Main Cloak & Body */}
      <g className="core-float-anim">
        {/* Back cape/cloak */}
        <path d="M 30 50 C 15 80 15 125 20 145 L 80 145 C 85 125 85 80 70 50 Z" className="g-fill-b g-stroke-bg" strokeWidth="1.2" opacity="0.6" />

        {/* Main Robes */}
        <path d="M 35 45 C 20 70 20 120 28 145 L 72 145 C 80 120 80 70 65 45 C 60 55 40 55 35 45 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.5" opacity="0.9" />

        {/* Inner Robe Folds / Tech details */}
        <polygon points="40,55 45,145 35,145" className="g-fill-b g-stroke-bg" strokeWidth="1" opacity="0.8" />
        <polygon points="60,55 65,145 55,145" className="g-fill-b g-stroke-bg" strokeWidth="1" opacity="0.6" />

        {/* Data cables draped around body */}
        <path d="M 28 100 Q 40 120 45 145" fill="none" className="g-stroke-core" strokeWidth="1.5" opacity="0.7" />
        <path d="M 72 90 Q 60 110 55 145" fill="none" className="g-stroke-a" strokeWidth="1.5" opacity="0.8" />
        <path d="M 30 120 Q 50 130 70 115" fill="none" className="g-stroke-b" strokeWidth="2" strokeDasharray="3,3" opacity="0.9" />
        <path d="M 40 110 C 45 120 55 120 60 110" fill="none" className="g-stroke-core" strokeWidth="1" strokeDasharray="1,2" opacity="0.6" />
        <path d="M 25 130 Q 30 140 35 145" fill="none" className="g-stroke-a" strokeWidth="1.5" />

        {/* Shoulders and Armor */}
        <path d="M 25 45 L 35 30 L 45 40 Z" className="g-fill-b g-stroke-bg" strokeWidth="1.2" />
        <path d="M 75 45 L 65 30 L 55 40 Z" className="g-fill-b g-stroke-bg" strokeWidth="1.2" />

        {/* Cybernetic Neck / Collar */}
        <polygon points="40,35 60,35 65,45 35,45" className="g-fill-a g-stroke-bg" strokeWidth="1.2" />
        <line x1="45" y1="35" x2="45" y2="45" className="g-stroke-bg" strokeWidth="1.5" />
        <line x1="50" y1="35" x2="50" y2="45" className="g-stroke-bg" strokeWidth="1.5" />
        <line x1="55" y1="35" x2="55" y2="45" className="g-stroke-bg" strokeWidth="1.5" />

        {/* Hood */}
        <path d="M 35 30 C 35 5 65 5 65 30 C 65 40 50 45 50 45 C 50 45 35 40 35 30 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.5" />

        {/* Hood inner shadow (face area) */}
        <path d="M 40 28 C 40 15 60 15 60 28 C 60 38 50 42 50 42 C 50 42 40 38 40 28 Z" className="g-cutout" />

        {/* Glowing Cybernetic Visor inside hood */}
        <g className="face-pulse-anim" style={{ transformOrigin: '50px 28px' }}>
          <path d="M 43 25 L 57 25 L 55 29 L 45 29 Z" className="g-fill-core" />
          <circle cx="47" cy="27" r="1.5" className="g-cutout" />
          <circle cx="53" cy="27" r="1.5" className="g-cutout" />
          <polygon points="50,30 53,35 47,35" className="g-fill-core" opacity="0.9" />
          <line x1="42" y1="27" x2="58" y2="27" className="g-stroke-a" strokeWidth="0.5" />
        </g>

        {/* Glowing Core held in hands */}
        <g className="g-pulse">
          <circle cx="50" cy="75" r="8" className="g-fill-core" opacity="0.9" />
          <circle cx="50" cy="75" r="12" fill="none" className="g-stroke-core" strokeWidth="1" strokeDasharray="2,2" />
          <circle cx="50" cy="75" r="4" className="g-fill-a" opacity="0.5" />
        </g>

        {/* Hands / Gauntlets holding the core */}
        <polygon points="32,65 42,72 38,82 28,70" className="g-fill-a g-stroke-bg" strokeWidth="1.2" />
        <polygon points="68,65 58,72 62,82 72,70" className="g-fill-a g-stroke-bg" strokeWidth="1.2" />

        {/* Fingers (Tech Claws) */}
        <path d="M 42 72 L 46 70" className="g-stroke-a" strokeWidth="1.5" />
        <path d="M 40 76 L 45 74" className="g-stroke-a" strokeWidth="1.5" />
        <path d="M 38 82 L 44 80" className="g-stroke-a" strokeWidth="1.5" />

        <path d="M 58 72 L 54 70" className="g-stroke-a" strokeWidth="1.5" />
        <path d="M 60 76 L 55 74" className="g-stroke-a" strokeWidth="1.5" />
        <path d="M 62 82 L 56 80" className="g-stroke-a" strokeWidth="1.5" />

        {/* Sleeve drapes */}
        <path d="M 35 45 C 15 65 15 85 28 70 C 25 55 35 45 35 45 Z" className="g-fill-b g-stroke-bg" strokeWidth="1.2" />
        <path d="M 65 45 C 85 65 85 85 72 70 C 75 55 65 45 65 45 Z" className="g-fill-b g-stroke-bg" strokeWidth="1.2" />

        {/* Tech base / ground connection */}
        <path d="M 28 145 L 72 145 L 68 150 L 32 150 Z" className="g-fill-a g-stroke-bg" strokeWidth="1" />
        <polygon points="35,145 40,150 45,145" className="g-fill-core" opacity="0.6" />
        <polygon points="55,145 60,150 65,145" className="g-fill-core" opacity="0.6" />
        <line x1="32" y1="145" x2="28" y2="150" className="g-stroke-core" strokeWidth="1" />
        <line x1="68" y1="145" x2="72" y2="150" className="g-stroke-core" strokeWidth="1" />
      </g>

      {/* Floating digital artifacts around the core */}
      <g className="g-sway-a">
        <polygon points="25,60 27,57 30,60 27,63" className="g-fill-a" />
        <circle cx="30" cy="90" r="1.5" className="g-fill-b" />
        <rect x="75" y="60" width="2" height="4" className="g-fill-core" />
        <path d="M 22 75 L 25 73 L 25 77 Z" className="g-fill-a" />
      </g>
      <g className="g-sway-b">
        <polygon points="75,95 79,92 77,98" className="g-fill-a" />
        <circle cx="75" cy="50" r="1.5" className="g-fill-core" />
        <rect x="20" y="85" width="4" height="1" className="g-fill-b" />
        <polygon points="70,80 72,78 74,80 72,82" className="g-fill-b" />
      </g>
    </svg>
  );
}
